import {ProductSelectItem} from "../ProductItem";
import {Section} from "./Section";


export class ProductSelectSection extends Section {
  constructor(sectionElement, allProductSelectionItems, allProductSelectionItemInstances) {
    super(sectionElement)

    this.productSelectionItems = [...allProductSelectionItems];
    this.productSelectItemInsances = allProductSelectionItemInstances;
    this.productSelectButton = this.element.querySelector('[data-button="select"]');
  }

  get activeSelectionElement() {
    return this.productSelectionItems.find(selectItemElement => {
      return selectItemElement.getAttribute('data-active') === 'true'
    });
  }

  get activeSelectionInstance() {
    return this.productSelectItemInsances.find(selectionInstance => {
      return selectionInstance.element.getAttribute('data-product-id') === this.activeSelectionElement.getAttribute('data-product-id')
    });
  }
}

export const INSTANTIATE_PRODUCT_SELECT_SECTION = () => {
  const PRODUCT_SELECT_SECTION_ELEMENT = document.querySelector('[data-section="product-select"]');
  if (!PRODUCT_SELECT_SECTION_ELEMENT) return;

  const PRODUCT_SELECT_ITEM_ELEMENTS = PRODUCT_SELECT_SECTION_ELEMENT.querySelectorAll('[data-product-id]');
  if (Array.from(PRODUCT_SELECT_ITEM_ELEMENTS).length === 0) return;

  const PRODUCT_SELECT_INSTANCES = Array.from(PRODUCT_SELECT_ITEM_ELEMENTS).map(selectItem => {
    return new ProductSelectItem(selectItem, Array.from(PRODUCT_SELECT_ITEM_ELEMENTS));
  })

  return new ProductSelectSection(PRODUCT_SELECT_SECTION_ELEMENT, Array.from(PRODUCT_SELECT_ITEM_ELEMENTS), PRODUCT_SELECT_INSTANCES);
}
